/**
 * Represents a property of an event.
 */
class EventProperty {
  constructor(key, value, isFinite) {
    this.key = key;
    this.value = value;
    this.isFinite = isFinite;
  }
}

module.exports = EventProperty;
